/* eslint-disable */
import i18n from "../i18n";
import { ofType, ActionsObservable } from "redux-observable";
import { switchMap, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { deauthenticate, loginTypes, loginSignIn } from "../actions/login";
import { Headers } from "../utils/Headers";
import { User } from "../utils/Authenticate";
import { API_URL } from "../config/settings";
import { toast } from "react-toastify";
import { DEFAULT_DIAL_CODE, normalizePhone } from "../config/countries";

/**
 * The backend validates with validator.isMobilePhone(), whose de-DE pattern
 * rejects spaces and dashes, so normalise before building the E.164 string.
 * countryCode is defaulted for safety: a caller that forgets it would otherwise
 * send "undefined888123456" with no error.
 */
const buildE164 = (countryCode, phoneNumber) => {
  const dialCode = countryCode || DEFAULT_DIAL_CODE;
  return `${dialCode}${normalizePhone(phoneNumber, dialCode)}`;
};

export const loginValidateTokenEpic = (action$) => {
  return action$.pipe(
    ofType(loginTypes.LOGIN_VALIDATE_TOKEN),
    switchMap(() => {
      return ajax({
        url: `${API_URL}/user/check`,
        method: "POST",
        headers: Headers.auth(),
        body: JSON.stringify({ email: "dummyEmailCheck@abc.bg" }),
      }).pipe(
        switchMap(() => of()),
        catchError((err) => {
          if (err.status === 401) {
            toast.error(err.response?.message);
            User.removeUserCredentials();
            window.location.href = "/login";
            return of(deauthenticate());
          }
          return of();
        })
      );
    })
  );
};

export const loginRequestEpic = (action$) => {
  return action$.pipe(
    ofType(loginTypes.LOGIN_SIGN_IN),
    switchMap(({ payload }) => {
      const credentials = {
        token: payload.token,
        user: payload.user,
      };
      toast.success(i18n.t("app:loggedIn"));
      User.storeUserCredentials(credentials);
      window.location.href = "/";
      return of();
    })
  );
};

export const logoutRequestEpic = (action$) => {
  return action$.pipe(
    ofType(loginTypes.DEAUTHENTICATE),
    switchMap(() => {
      return ajax({
        url: `${API_URL}/user/logout`,
        method: "GET",
        headers: Headers.auth(),
      }).pipe(
        switchMap(() => {
          User.removeUserCredentials();
          window.location.href = "/login";
          return of();
        }),
        catchError(() => {
          return of();
        })
      );
    })
  );
};

export const sendCodeEpic = (action$) => {
  return action$.pipe(
    ofType(loginTypes.SEND_CODE),
    switchMap(({ payload }) => {
      return ajax({
        url: `${API_URL}/code/create`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phoneNumber: buildE164(payload.countryCode, payload.phoneNumber),
        }),
      }).pipe(
        switchMap(({ response }) => {
          if (payload.onSuccess) {
            payload.onSuccess(response);
          }
          return of();
        }),
        catchError((err) => {
          if (payload.onSuccess) {
            const errorResponse = {
              success: false,
              message: err.response?.message || i18n.t("validation:errSendCode"),
            };
            payload.onSuccess(errorResponse);
          } else {
            toast.error(err.response?.message || i18n.t("validation:errSendCode"));
          }
          return of();
        })
      );
    })
  );
};

export const verifyCodeEpic = (action$) => {
  return action$.pipe(
    ofType(loginTypes.VERIFY_CODE),
    switchMap(({ payload }) => {
      return ajax({
        url: `${API_URL}/code/use`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phoneNumber: buildE164(payload.countryCode, payload.phoneNumber),
          code: parseInt(payload.code),
          isMobile: window.innerWidth < 900,
        }),
      }).pipe(
        switchMap(({ response }) => {
          if (payload.onSuccess) {
            payload.onSuccess(response);
          }

          if (response.success) {
            return of(
              loginSignIn({
                token: response.token,
                user: response.user,
              })
            );
          }
          return of();
        }),
        catchError((err) => {
          if (payload.onSuccess) {
            const errorResponse = {
              success: false,
              message: err.response?.message || i18n.t("validation:errVerifyCode"),
            };
            payload.onSuccess(errorResponse);
          } else {
            toast.error(err.response?.message || i18n.t("validation:errVerifyCode"));
          }
          return of();
        })
      );
    })
  );
};
